import {
  AlibabaCloudIcon,
  AnthropicIcon,
  BlackForestLabsIcon,
  DeepSeekIcon,
  FalIcon,
  GoogleIcon,
  KlingIcon,
  LumaIcon,
  MidjourneyIcon,
  MinimaxIcon,
  OpenAiIcon,
  ReplicateIcon,
  RunwayIcon,
  VercelIcon,
  XaiIcon,
  JimengIcon,
  BytedanceIcon,
  RecraftIcon,
  StableIcon,
  TopazIcon,
  ElevenLabsIcon,
  ViduIcon,
  SunoIcon,
  ZhipuIcon,
  FlowMuseIcon,
  HunyuanIcon,
  Hyper3dIcon,
  Tripo3dIcon,
  PixverseIcon,
  MoonshotIcon,
  XiaomiIcon,
  IdeogramIcon,
  MurekaIcon,
  KreaIcon,
  MicrosoftIcon,
  NvidiaIcon,
  SkyworkIcon,
  ReveIcon,
} from './icons';
import {
  providers as providersCore,
  type TersaModel as TersaModelCore,
  type TersaProvider as TersaProviderCore,
} from '@flowmuse/models/providers';

// provider 纯数据（id/name）已下沉到 @flowmuse/models/providers（供独立 API 服务复用），
// 这里合并 React 图标后导出给 UI；类型形状与拆分前保持一致。
export type TersaProvider = TersaProviderCore & {
  icon: typeof OpenAiIcon;
};

const providerIcons: Record<keyof typeof providersCore, typeof OpenAiIcon> = {
  openai: OpenAiIcon,
  anthropic: AnthropicIcon,
  google: GoogleIcon,
  xai: XaiIcon,
  vercel: VercelIcon,
  luma: LumaIcon,
  minimax: MinimaxIcon,
  'black-forest-labs': BlackForestLabsIcon,
  deepseek: DeepSeekIcon,
  runway: RunwayIcon,
  jimeng: JimengIcon,
  alibaba: AlibabaCloudIcon,
  fal: FalIcon,
  kling: KlingIcon,
  replicate: ReplicateIcon,
  midjourney: MidjourneyIcon,
  bytedance: BytedanceIcon,
  recraft: RecraftIcon,
  stable: StableIcon,
  topaz: TopazIcon,
  elevenlabs: ElevenLabsIcon,
  vidu: ViduIcon,
  suno: SunoIcon,
  mureka: MurekaIcon,
  zhipu: ZhipuIcon,
  moonshot: MoonshotIcon,
  xiaomi: XiaomiIcon,
  flowmuse: FlowMuseIcon,
  hunyuan: HunyuanIcon,
  hyper3d: Hyper3dIcon,
  tripo3d: Tripo3dIcon,
  pixverse: PixverseIcon,
  ideogram: IdeogramIcon,
  krea: KreaIcon,
  microsoft: MicrosoftIcon,
  nvidia: NvidiaIcon,
  skywork: SkyworkIcon,
  reve: ReveIcon,
};

export const providers = Object.fromEntries(
  (Object.keys(providersCore) as Array<keyof typeof providersCore>).map((key) => [
    key,
    { ...providersCore[key], icon: providerIcons[key] },
  ]),
) as { [K in keyof typeof providersCore]: TersaProvider };

/**
 * 按 provider id 取图标。图像/视频模型注册表来自 @flowmuse/models（纯数据、无 icon），
 * UI 从模型数据读图标时用此函数兜底。
 */
export function getProviderIcon(id: string | null | undefined): typeof OpenAiIcon | undefined {
  if (!id) return undefined;
  return (providerIcons as Record<string, typeof OpenAiIcon>)[id];
}

export type TersaModel = Omit<TersaModelCore, 'icon' | 'chef' | 'providers'> & {
  // Inherits from chef if not provided
  icon?: typeof OpenAiIcon;
  chef: TersaProvider;
  providers: TersaProvider[];
};
